<template>
  <div>
    <app-overlay-loader v-if="preloader" />
    <legend>
      <p class="text-primary">
        <b> Borrador del Informe del Director de Área.</b>
      </p>
    </legend>

    <form
      :class="{ 'loading-opacity': preloader }"
      ref="form"
      :data-url="
        selectedUrl ? `/technicalReport/${inputs.id}` : `/technicalReport`
      "
    >
      <!-- //HEADER-->
      <legend>
        <p class="text-primary"><small>Cabecera del informe</small></p>
      </legend>

      <div class="row">
        <div class="col-sm">
          <div class="form-group">
            <!-- <label class="mb-0">Fecha de documento: </label> -->
            <app-input
              type="date"
              v-model="inputs.report_date"
              placeholder="Ingrese la fecha del documento."
              :required="true"
              :disabled="true"
              :hidden="true"
            />
          </div>
        </div>
        <div class="col-sm">
          <div class="form-group">
            <!-- <label class="mb-0">Nº Memorando: </label> -->
            <app-input
              type="text"
              v-model="inputs.memorando"
              placeholder="Ingrese el número de memorando"
              :disabled="true"
              :hidden="true"
            />
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-sm">
          <div class="form-group">
            <!-- <label class="mb-0">De: </label> -->
            <app-input
              type="text"
              v-model="name_from"
              :disabled="true"
              :hidden="true"
              v-if="name_from"
            />
            <app-input
              type="text"
              v-model="full_name_from"
              :hidden="true"
              :disabled="true"
              v-if="!name_from"
            />
          </div>
        </div>

        <div class="col-sm">
          <div class="form-group">
            <!-- <label class="mb-0">Para: </label> -->
            <app-input
              type="text"
              v-model="full_name_to"
              :disabled="true"
              :hidden="true"
              v-if="full_name_to"
            />
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-sm">
          <div class="form-group">
            <label class="mb-0">Asunto: </label>
            <app-input
              type="text"
              v-model="inputs.matter"
              placeholder="Ingrese el asunto"
              :required="true"
              :disabled="status"
            />
          </div>
        </div>
      </div>

      <legend>
        <p class="text-primary"><small>Contenido del informe.</small></p>
      </legend>

      <div class="row">
        <div class="col-12">
          <div class="form-group">
            <quill-editor
              v-model="inputs.paragraph"
              :options="editorOption"
              :disabled="status"
            />
          </div>
        </div>
      </div>

      <hr />
      <br /><br />

      <!-- //PARRAFOS  - LINEAS  |  DETALLES-->
      <button
        type="button"
        class="btn btn-primary"
        @click="submit"
        v-if="!status"
      >
        Guardar
      </button>
    </form>
  </div>
</template>

<script>
import { FormMixin } from "@/core/mixins/form/FormMixin.js";
import * as actions from "../../../../apiURL";
import { quillEditor } from "vue-quill-editor";

export default {
  mixins: [FormMixin],
  components: { quillEditor },

  data() {
    return {
      accreditation_id: null,
      preloader: false,
      status: false,
      inputs: {
        report_date: new Date(),
      },
      user_id: 0,
      name_from: "",
      full_name_from: String,
      full_name_to: String,

      editorOption: {
        modules: {
          toolbar: [
            [{ size: ["small", false, "large", "huge"] }],
            ["bold", "italic", "underline"],
            [{ align: [] }],
            [{ indent: "-1" }, { indent: "+1" }],
            [{ color: [] }, { background: [] }],
            [{ list: "ordered" }, { list: "bullet" }],
            ["clean"],
          ],
        },
        theme: "snow", // or 'bubble'
      },
    };
  },

  watch: {},
  created() {
    this.info();
  },
  methods: {
    submit() {
      const d = this.inputs.report_date;
      this.inputs.report_date = [
        d.getFullYear(),
        d.getMonth() + 1,
        d.getDate(),
      ].join("-");

      this.save(this.inputs);
    },
    info() {
      if (this.$store.state.evaluatorReview) {
        this.preloader = true;
        this.axiosGet(`/userInfo`).then((response) => {
          this.user_id = response.data.id;
          this.full_name_from = response.data.full_name;
        });

        this.axiosGet(
          `/technicalReport/${this.$store.state.evaluatorReview.evalTestId}`
        )
          .then((response) => {
            if (response.data.from_user) {
              this.name_from = response.data.from_user.full_name;
            }
            let date = new Date();
            date.setDate(date.getDate());
            if (response.status == 200 && response.data) {
              this.inputs = response.data;
              this.inputs.id_technical_report =
                response.data.id_technical_report;
              this.inputs.from = this.user_id;
              this.inputs.accreditation_id = response.data.id;
              this.inputs.report_date = new Date(date);
              this.inputs.receiver = response.data.area_director;
              this.full_name_to = response.data.full_name;
              if (response.data.code_status != "605") {
                this.status = true; // solo lectura - consulta de une stado anterior esta TAB.
              }
            }
          })
          .catch((error) => {
            console.log(error);
          })
          .finally(() => {
            this.preloader = false;
          });
      }
    },
    afterSuccess(response) {
      if (this.selectedUrl) {
        this.$toastr.s(this.$t("updated_success"));
      } else {
        this.$toastr.s(this.$t("created_success"));
      }
    },
    afterSuccessFromGetEditData(response) {
      this.preloader = false;
    },
    afterFinalResponse() {
      this.preloader = false;
      this.info();
    },
  },
};
</script>
